// #region Dependencias
import { Form, Input } from 'components/Library'
// #endregion

/**
 * Componente que maneja la edición de tipo de letra de landing pages.
 * @class
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.formValues - Objeto con los valores de los campos del formulario de la página.
 * @param {Function} props.handleInputChange - Callback para actualizar los valores de un elemento de la página.
 */
const MenuFont = ({ formValues, handleInputChange }) => {
  return (
    <Form
      style={{
        padding: '1rem'
      }}
    >
      <Input
        label="Enlace"
        helper="Enlace de importación de la fuente"
        name="opciones.fuente.url"
        placeholder="https://fonts.googleapis.com/css2?family=Poppins&display=swap"
        onChange={handleInputChange}
        value={formValues.opciones.fuente.url}
      />
      <Input
        label="Nombre"
        helper="Nombre y forma de uso de la fuente"
        name="opciones.fuente.nombre"
        placeholder="'Poppins', sans-serif"
        onChange={handleInputChange}
        value={formValues.opciones.fuente.nombre}
      />
    </Form>
  )
}

export default MenuFont
